import { css } from 'styled-components';

export const checkedMixin = (props: any) => {
  if (props.value) {
    return css`
      background-color: #fff !important;
      border: 2px solid ${(props) => props.theme.colors.checkboxChecked} !important;
      color: ${(props) => props.theme.colors.checkboxChecked};

      &:after {
        content: '\\2714';
        font-size: 12px;
        font-weight: bold;
        position: absolute;
        top: -2px;
        left: 2px;
        color: ${(props) => props.theme.colors.checkboxChecked};
      }
    `;
  }
  return css`
    background-color: #fff !important;
    border: 1px solid ${(props) => props.theme.colors.inputBorder} !important;
    &:after {
      font-size: 8px;
      position: absolute;
      top: 1px;
      left: 3px;
      color: #ffffff;
    }
  `;
};
